import { Dialog, Transition } from '@headlessui/react'
import { isFunction } from 'lodash'
import { Fragment } from 'react'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import usePopupStore from '../../../../../store/usePopupStore'

interface IBasicModalProps {
  id: string
}
const BasicModal = ({ id }: IBasicModalProps) => {
  const popupClose = usePopupStore((state) => state.close)
  const { data } = usePopupStore((state) => ({
    data: state.data[id],
  }))
  const { title = '', body = undefined, buttons = undefined } = data ? data : {}
  const { t } = useTranslation()
  const closeModal = () => {
    popupClose({ id })
  }
  const { onClose = null } = data ? data : {}
  const open = data ? true : false
  const closeHandler = () => {
    popupClose({ id })
    if (isFunction(onClose)) {
      onClose()
    }
  }

  const defaultButton = { onClick: buttons?.left?.onClick ?? closeModal, label: t(n_caf.fluency.modal_okay) }
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeHandler}>
        {/* BackDrop */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="bg-dim fixed inset-0" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-[80%] transform overflow-hidden rounded-[10px] bg-white align-middle transition-all">
                <>
                  <div className={`z-[999] rounded-[10px] border-gray-100 bg-white p-0`}>
                    {/* title */}
                    <h2 className="text-h2 py-[26px] px-[16px]  text-center font-bold">{title}</h2>
                    {/* body */}
                    <p className="mb-[30px] px-[16px] text-left text-[12px] leading-[22px] tracking-tighter">{body}</p>
                    {/* button wrapper*/}
                    <div className={`flex w-full border-t border-t-gray-100 py-[10px] text-center`}>
                      {buttons?.right ? (
                        <>
                          <button
                            className={`w-full cursor-none select-none font-medium text-gray-500`}
                            onClick={buttons.left.onClick}
                          >
                            {buttons.left.label}
                          </button>
                          <div className="w-[1px] bg-gray-200 h-[34px]" />
                          <button
                            className={`w-full cursor-none select-none font-medium text-purple-500`}
                            onClick={buttons.right.onClick}
                          >
                            {buttons.right.label}
                          </button>
                        </>
                      ) : (
                        <button
                          className={`w-full cursor-none select-none py-[5px] font-medium text-purple-500`}
                          onClick={defaultButton.onClick}
                        >
                          {defaultButton.label}
                        </button>
                      )}
                    </div>
                  </div>
                </>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
export default BasicModal
